"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _NoncurrentVersionTransition_1 = require("./_NoncurrentVersionTransition");
exports._NoncurrentVersionTransitionList = {
    type: "list",
    flattened: true,
    member: {
        shape: _NoncurrentVersionTransition_1._NoncurrentVersionTransition
    }
};
//# sourceMappingURL=_NoncurrentVersionTransitionList.js.map